import { EditIcon } from 'assests/GmsIcons';
import React from 'react';

export type DetailSectionConfig = {
    type: 'party' | 'domain' | 'channel';
    data: {
        title: string;
        partyName?: string; 
        partyType?: string; 
        address?: string; 
        description?: string; 
    };
    onEdit?: () => void;
};

const DetailSection: React.FC<{ config: DetailSectionConfig }> = ({ config }) => {
    const { type, data, onEdit } = config;
    
    return (
        <div className="tw-w-full">
            <div className="tw-w-full tw-h-[168px] tw-p-3 tw-bg-[#f4f5f7] tw-rounded-[4px] tw-mt-4">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2.5">
                    <div className="tw-text-[#091E42] tw-text-[24px] tw-font-semibold">{data.title}</div>
                    {onEdit && (
                        <div className="tw-cursor-pointer tw-p-1 hover:tw-bg-gray-200 tw-rounded" onClick={onEdit}>
                            <EditIcon />
                        </div>
                    )}
                </div>
                
                {type !== 'party' && data.partyName && (
                    <div className="tw-mt-4 tw-px-1">
                        <div className="tw-text-[#969fae] tw-text-xs tw-font-medium tw-leading-tight">Party</div>
                        <div className="tw-text-[#172b4d] tw-text-sm tw-font-semibold tw-leading-tight tw-mt-1">{data.partyName}</div>
                    </div>
                )}
                
                {type === 'party' && data.partyType && (
                    <div className="tw-mt-4 tw-px-1">
                        <div className="tw-text-[#969fae] tw-text-xs tw-font-medium tw-leading-tight">Party Type</div>
                        <div className="tw-text-[#172b4d] tw-text-sm tw-font-semibold tw-leading-tight tw-mt-1">{data.partyType}</div>
                    </div>
                )}
                
                <div className="tw-mt-4 tw-px-1">
                    <div className="tw-text-[#969fae] tw-text-xs tw-font-medium tw-leading-tight">
                        {type === 'party' ? 'Address' : 'Description'}
                    </div>
                    <div className="tw-text-[#172b4d] tw-text-sm tw-font-semibold tw-leading-tight tw-mt-1">
                        {type === 'party' ? data.address : data.description}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DetailSection;